import { render, staticRenderFns } from "./addGuest.vue?vue&type=template&id=35b8c4aa"
import script from "./addGuest.vue?vue&type=script&lang=js"
export * from "./addGuest.vue?vue&type=script&lang=js"
import style0 from "./addGuest.vue?vue&type=style&index=0&id=35b8c4aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports